
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommercialSaleItemComponent } from './commercial-sale-item.component';
import { ICommercialSale } from 'src/models/commercial/ICommercialSale';

@Component({
    selector: 'commercial-sales-list',
    imports: [CommercialSaleItemComponent],
    templateUrl: './commercial-sales-list.component.html',
    styleUrl: './commercial-sales-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommercialSalesListComponent {
    sales = input.required<ICommercialSale[]>();
}
